import { DiscountTarget, DiscountType } from '../../types';
import { settlementTexts } from '../text';

export const discountTargetMapper: Record<DiscountTarget, string> = {
    [DiscountTarget.MEAL]: settlementTexts.discounts.general.meals,
    [DiscountTarget.STAY]: settlementTexts.discounts.general.stay,
    [DiscountTarget.EXTRA_LESSONS]: settlementTexts.discounts.general.extraLessons,
    [DiscountTarget.ADDITIONAL_COST]: 'Dodatkowe koszty',
    [DiscountTarget.ALL_COSTS]: 'Wszystkie koszty',
};

export const discountTypeMapper: Record<DiscountType, string> = {
    [DiscountType.VALUE_DISCOUNT]: settlementTexts.discounts.general.valueDiscount,
    [DiscountType.PERCENTAGE_DISCOUNT]: settlementTexts.discounts.general.percentageDiscount,
};
